module.exports = __webpack_public_path__ + "components/country-flag/static/br-cc734410e0c96eea9bd69b1bd8e063be.svg";